const APIURLConstants = {
    GET_APPLICATION_DETAILS: 'api/ApplicationDetails',
    GET_APP_DETAILS: 'api/AppDetails',
    SET_USER_AS: (userID) => `api/SetUserAs?userID=${userID}`,
    POST_EVENT_INFO: 'letsgoapi/api/Event',
    POST_EVENT_BRANDING_INFO: 'letsgoapi/api/EventBrandingColor',
    GET_EVENT_LIST: 'letsgoapi/api/EventList',
    GET_EVENT_MODULE_DETAILS: (eventID) => `letsgoapi/api/EventModuleDetails/${eventID}`,
    GET_EVENT: (eventID, userID) => `letsgoapi/api/GetEvent/${eventID}/${userID}`,
    GET_EVENT_LOCATION: (eventID) => `letsgoapi/api/GetEventLocation/${eventID}`,
    IS_AGENT: (userID, eventID) => `letsgoapi/api/IsAgent/${userID}/${eventID}`,
    GET_EVENT_MENU_CONFIG_LIST: (eventID) => `letsgoapi/api/EventMenuConfigList/${eventID}`,
    GET_ALL_EVENTS: 'letsgoapi/api/AllEvents',
    DELETE_EVENTS: 'letsgoapi/api/DeleteEvents',
    GET_USERS_LIST: 'letsgoapi/api/LETSGOUsersDetails',
    POST_INS_AIR_TRANSPORT: 'letsgoapi/api/InsAirTransport',
    POST_SET_AIR_EMAIL_NOTIFICATION: 'letsgoapi/api/SetAirEmailNotification',
    POST_SET_COMBINE_AIR_EMAIL_NOTIFICATION:
        'letsgoapi/api/SetDraftCombineAirEmailNotification',
    POST_SET_GROUND_EMAIL_NOTIFICATION:
        'letsgoapi/api/SetGroundEmailNotification',
    POST_SET_VIP_EMAIL_NOTIFICATION: 'letsgoapi/api/SetVIPEmailNotification',
    POST_SET_ALLSTAR_TICKET_EMAIL_NOTIFICATION:
        'letsgoapi/api/SetTicketAllStarEmailNotification',
    POST_SET_HOTEL_EMAIL_NOTIFICATION:
        'letsgoapi/api/SetHotelEmailNotification',
    POST_SET_REGISTRATION_EMAIL_NOTIFICATION:
        'letsgoapi/api/SetRegistrationEmailNotification',
    POST_SET_SAT_NIGHT_EMAIL_NOTIFICATION:
        'letsgoapi/api/SetSatNightEmailNotification',
    POST_UPD_AIR_TRANSPORT: 'letsgoapi/api/UpdAirTransport',
    POST_UPD_GND_TRANSPORT: 'letsgoapi/api/InsUpdGroundTransport',
    GET_TRANSPORT_LIST: (eventID, userID, currentPage, perPage) =>
        `letsgoapi/api/GetTransportList/${eventID}/${userID}/${currentPage}/${perPage}`,
    GET_AIRTRANSPORT_ROW: (transitID) =>
        `letsgoapi/api/GetAirTransportRow/${transitID}`,
    GET_GNDTRANSPORT_ROW: (transitID) =>
        `letsgoapi/api/GetGroundTransportRow/${transitID}`,
    GET_ROLES: (eventID) => `letsgoapi/api/Roles/${eventID}`,
    GET_TAGS: (eventID) => `letsgoapi/api/Tags/${eventID}`,
    GET_EVENT_TAGS: (eventID) => `letsgoapi/api/EventTags/${eventID}`,
    GET_USER_TAGS: (eventID, userID) =>
        `letsgoapi/api/GetUserTags/${eventID}/${userID}`,
    GET_SYSTEM_USERS: 'letsgoapi/api/SystemUsers',
    GET_EVENT_PARTICIPANTS: (eventID, currentPage, perPage, sort) =>
        `letsgoapi/api/EventParticipants/${eventID}/${currentPage}/${perPage}/${sort}`,
    GET_ADMIN_EVENT_PARTICIPANTS: (eventID) =>
        `letsgoapi/api/AdminEventParticipants/${eventID}`,
    GET_TEMPLATES: (eventID) => `letsgoapi/api/GetTemplates/${eventID}`,
    POST_EVENT_PARTICIPANTS: `letsgoapi/api/AddParticipants`,
    POST_EVENT_PARTICIPANT_ROW: `letsgoapi/api/UpdEventParticipant`,
    DELETE_EVENT_PARTICIPANTS: 'letsgoapi/api/DeleteParticipants',
    DELETE_EVENT_PARTICIPANTS_FROM_TAG: 'letsgoapi/api/DeleteParticipantsFromTag',

    GET_MODULE_LIST: 'letsgoapi/api/ModuleList',
    POST_MODULES: `letsgoapi/api/AddModules`,
    GET_EVENT_MODULES: (eventID, type, IsSchedule, sendDetails = false) =>
        `letsgoapi/api/EventModuleList/${eventID}/${type}/${IsSchedule}/${sendDetails}`,
    GET_EVENT_STAFF_MODULES: (eventID, userID) =>
        `letsgoapi/api/EventStaffModuleList/${eventID}/${userID}`,
    GET_USER_PROFILE: `letsgoapi/api/GetUserProfile`,
    POST_USER_PROFILE: `letsgoapi/api/UserProfile`,
    POST_ADD_TAG: `letsgoapi/api/AddTag`,
    POST_DELETE_TAG: `letsgoapi/api/DeleteTags`,
    POST_ROLES: `letsgoapi/api/AddRole`,
    DELETE_ROLES: `letsgoapi/api/DeleteRoles`,
    POST_REGISTRATION_INFO: `letsgoapi/api/RegistrationInfo`,
    GET_REGISTRATION_FORM: (eventID) =>
        `letsgoapi/api/GetEventRegistrationForm/${eventID}`,
    GET_LEAGUES: `letsgoapi/api/Leagues`,
    GET_TEAMS: (league) => `letsgoapi/api/Teams/${league}`,
    GET_VALID_EMAIL: (email) => `letsgoapi/api/ValidateEmail/${email}`,
    GET_VALID_LOGIN_ID: (email) => `letsgoapi/api/ValidateLogin/${email}`,
    GET_USER_DETAILS_BY_CODE:(userCode) => `letsgoapi/api/UserDetailsByCode/${userCode}`,
    POST_USER: `letsgoapi/api/InsertUser`,
    GET_USER: (userID) => `letsgoapi/api/GetSystemUser/${userID}`,
    GET_EVENT_REGISTRATION: (registrationID) =>
        `letsgoapi/api/GetEventRegistration/${registrationID}`,
    GET_EVENT_REGISTRATION_INFO: (eventID, userID) =>
        `letsgoapi/api/EventRegistrationInfo/${eventID}/${userID}`,
    GET_ALL_USER_LIST: (currentPage, perPage) =>
        `letsgoapi/api/GetAllUser/${currentPage}/${perPage}`,
    GET_USER_TYPE: `letsgoapi/api/UserType`,
    GET_SYSTEM_TAGS: `letsgoapi/api/GetTags`,
    GET_EVENT_USERS: (userID, eventID) => `letsgoapi/api/EventUsers/${userID}/${eventID}`,
    SIGN_OUT: 'api/SignOut',
    GET_ADMIN_TRANSPORT_LIST: (eventID, currentPage, perPage) =>
        `letsgoapi/api/GetAdminTransportList/${eventID}/${currentPage}/${perPage}`,
    GET_SHARED_ADMIN_TRANSPORT_LIST: (transportID, shared, modifiedBy) =>
        `letsgoapi/api/UpdateSharedStatusTransportList/${transportID}/${shared}/${modifiedBy}`,
    GET_STATUS_ADMIN_TRANSPORT_LIST: (transportID, status, modifiedBy, isMail) =>
        `letsgoapi/api/UpdateStatusTransportList/${transportID}/${status}/${modifiedBy}/${isMail}`,
    POST_TRANSPORT_NOTE: 'letsgoapi/api/TransportNote',
    DELETE_TRANSPORT: 'letsgoapi/api/DeleteTransport',
    GET_HOTELBOOKING_LIST: (
        eventID,
        userID,
        isAdmin,
        expanded,
        currentPage,
        perPage
    ) =>
        `letsgoapi/api/GetHotelBookingList/${eventID}/${userID}/${isAdmin}/${expanded}/${currentPage}/${perPage}`,
    DELETE_HOTELBOOKING: 'letsgoapi/api/DeleteHotelRequest',
    DELETE_DRAFTHOTELBOOKING: 'letsgoapi/api/DeleteDraftHotelRequest',
    POST_HOTELBOOKING_NOTE: 'letsgoapi/api/HotelBookingNote',
    GET_MEExport: `letsgoapi/api/MEExport`,
    POST_STATUS_OR_SHARE_HOTEL: 'letsgoapi/api/UpdateStatusOrSharedRequest',
    POST_STATUS_OR_SHARE_DRAFT_HOTEL:
        'letsgoapi/api/DraftHotelUpdateStatusOrSharedRequest',
    GET_REGISTRATION_LIST: (eventID, currentPage, perPage) =>
        `letsgoapi/api/GetRegistrationList/${eventID}/${currentPage}/${perPage}`,
    GET_INVITATION_LIST: (eventID, currentPage, perPage) =>
        `letsgoapi/api/InvitationList/${eventID}/${currentPage}/${perPage}`,
    EditInvitation: (InvitationID) =>
        `letsgoapi/api/EditInvitation/${InvitationID}`,
    POST_ADD_INVITATION: 'letsgoapi/api/AddInvitation',
    ARCHIVE_INVITATION_EMAIL: `letsgoapi/api/ArchiveInvitation`,
    UPDATE_SHARED_STATUS_ADMIN_REGISTRATION:
        'letsgoapi/api/UpdateStatusOrSharedCombineRegRequest',
    UPDATE_REGISTRATION_NOTE: 'letsgoapi/api/EventRegistrationNote',
    UPDATE_EVENT_MODULE_ORDERS: 'letsgoapi/api/UpdateEventModuleOrder',
    DELETE_REGISTRATION: 'letsgoapi/api/DeleteEventRegRequest',
    DELETE_USERS: 'letsgoapi/api/DeleteUsers',
    DELETE_INVITATIONLIST: 'letsgoapi/api/DeleteInvitations',
    DELETE_TEMPLATES: 'letsgoapi/api/DeleteTemplates',
    POST_UPDATE_INVITATION: 'letsgoapi/api/UpdateInvitation',
    POST_UPDATE_MULTIPLAEINVITATION: 'letsgoapi/api/UpdateMultipleInvitation',
    POST_TEMPLATES: 'letsgoapi/api/EmailTemplate',
    POST_UPD_HOTEL: 'letsgoapi/api/InsUpdHotel',
    GET_DRAFTCOMBINE_SETTING_BY_USERID: (eventID, userID) =>
        `letsgoapi/api/GetDraftCombineHotelSettingByUserID/${eventID}/${userID}`,
    GET_AGENT_ROOM_REQUEST_BY_USERID: (eventID, moduleID, userID) => `letsgoapi/api/GetHotelAgentRoomRequest/${eventID}/${moduleID}/${userID}`,
    INS_UPD_HOTEL_AGENT_REQUEST: `letsgoapi/api/InsUpdHotelAgentRequest`,
    POST_SAVE_USER: 'letsgoapi/api/SaveUser',
    POST_SEND_EMAIL: 'letsgoapi/api/SendMail',
    POST_SEND_USER_INVITATION_EMAIL: 'letsgoapi/api/SendUserInvitationMail',
    POST_ADD_CONNECTION: `letsgoapi/api/AddConnection`,
    DELETE_CONNECTION_WITH: `letsgoapi/api/DeleteConnectionWith`,
    DELETE_CONNECTIONS: `letsgoapi/api/DeleteConnections`,
    DELETE_MULTIPLE_CONNECTIONS: `letsgoapi/api/DeleteMultipleConnections`,
    EDIT_MODULE_INFO: `letsgoapi/api/UpdateModuleInfo`,
    EDIT_APPROVE_MODULE_INFO: `letsgoapi/api/UpdateApproveModuleInfo`,
    // janrain login
    POST_VALIDATE_USER: 'letsgoapi/api/ValidateUser',

    //schedule api urls
    GET_USER_ACTIVITY_COUNT: (eventId, userId) =>
        `letsgoapi/api/GetUserActivityCount/${eventId}/${userId}`,
    GET_ACTIVITY_LIST: (eventId, userId) =>
        `letsgoapi/api/GetActivities/${eventId}/${userId}`,
    POST_ACTIVITY_LIST: 'letsgoapi/api/Activity',
    GET_ACTIVITY_PARTICIPANTS: (activityID) =>
        `letsgoapi/api/GetActivityParticipants/${activityID}`,
    DELETE_ACTIVITY_LIST: 'letsgoapi/api/DeleteActivity',
    POST_ACTIVITY_PARTICIPANTS: 'letsgoapi/api/savePartisipants',
    DELETE_ACTIVITY_PARTICIPANTS: 'letsgoapi/api/DeleteActivityParticipants',
    GET_AGENT_CONNECTIONS: (userID, eventID) =>
        `letsgoapi/api/GetAgentConnection/${userID}/${eventID}`,
    GET_EVENT_USER_MODULE_STATUS: (eventID, userID) =>
        `letsgoapi/api/GetEventUserModuleStatus/${eventID}/${userID}`,
    DELETE_USER_ACTIVITIES: 'letsgoapi/api/DeleteParticipantActivities',
    ASSIGN_ACTIVITY_TO_PARTICIPANTS:
        'letsgoapi/api/AssignActivityToParticipant',
    ACTIVITY_EXCEL_IMPORT: (userType) =>
        `letsgoapi/api/UploadActivity/${userType}`,
    ACTIVITY_MASS_EXCEL_IMPORT: (userType) =>
        `letsgoapi/api/UploadMassActivity/${userType}`,
    BULK_USER_EXCEL_IMPORT:
        'letsgoapi/api/UploadBulkUser',
    GET_EXCEL_ACTIVITY_TEMPLATE: 'letsgoapi/api/DownloadActivityExcelTemplate',
    INVITATION_EXCEL_IMPORT: 'letsgoapi/api/ImportInvitation',
    GET_EXCEL_INVITATION_TEMPLATE: (eventID) =>
        `letsgoapi/api/DownloadInvitationExcelTemplate/${eventID}`,
    GET_EVENT_USER_MODULES: (eventID, Type) =>
        `letsgoapi/api/GetEventUserModules/${eventID}/${Type}`,
    GET_EVENT_USER_EVENT_MODULES_PERMISSION: (eventID, userID, isAdmin) =>
        `letsgoapi/api/GetEventModulePermissions/${eventID}/${userID}/${isAdmin}`,

    GET_EVENT_ALL_USER_MODULE_STATUS: (eventID) =>
        `letsgoapi/api/GetEventAllUserModuleStatus/${eventID}`,
    GET_ACTIVITY_LIST_TAG: (eventID) =>
        `letsgoapi/api/GetActivityTags/${eventID}`,
    SYNC_ACTIVITY_PARTICIPANTS: (eventId) =>
        `letsgoapi/api/syncUserActivities/${eventId}`,
    REMOVE_ACTIVITY_BY_TAGID: (eventID) =>
        `letsgoapi/api/RemoveUserActivitiesByTag/${eventID}`,
    GET_CONNECTIONS: (userID, eventID) =>
        `letsgoapi/api/GetConnection/${userID}/${eventID}`,
    POST_USER_MODULE_PERMISSIONS: 'letsgoapi/api/UpdUserModules',
    GET_EVENT_USER_PERMISSIONS: (eventID, userID) =>
        `letsgoapi/api/GetEventPermissions/${eventID}/${userID}`,
    GET_USER_CONFIG: (userID, lastModifyBy) =>
        `letsgoapi/api/GetUserConfig/${userID}/${lastModifyBy}`,
    SAVE_EVENT_NOTIFICATION: 'letsgoapi/api/saveNotification',
    GET_OUTFIT_OPTIONS: (eventId) =>
        `letsgoapi/api/GetOutfitOptions/${eventId}`,
    POST_OUTFIT: 'letsgoapi/api/UpdateOutfit',
    GET_OUTFIT_LIST: (eventId) => `letsgoapi/api/GetUsersOutfit/${eventId}`,
    GET_USER_OUTFIT_INFO: (eventID, userID) =>
        `/letsgoapi/api/GetUserOutfitInfo/${eventID}/${userID}`,
    GET_EVENT_CONFIG: (eventID) => `letsgoapi/api/GetEventConfig/${eventID}`,
    GET_EVENT_TAG_DATES: (eventID, moduleID, tagID) => `letsgoapi/api/GetEventTagDates/${eventID}/${moduleID}/${tagID}`,
    GET_HOTEL_LIST: 'letsgoapi/api/GetHotelList',
    POST_EMAIL_NOTIFICATION: 'letsgoapi/api/GetEmailNotification',
    POST_COMMON_EMAIL_TEMPLATE: 'letsgoapi/api/CommonEmailTemplate',

    DELETE_OUTFITS: 'letsgoapi/api/DeleteOutfits',
    Excel_Export: `letsgoapi/api/ExcelExport`,
    SCHEDULE_EXPORT: `letsgoapi/api/ScheduleExport`,
    GET_MASS_SCHEDULE_EXCEL_EXPORT: `letsgoapi/api/MassScheduleExcelExport`,
    GET_BULK_USER_EXCEL_EXPORT: `letsgoapi/api/BulkUserExcelExport`,
    GET_DRAFT_EXCEL_EXPORT: (eventID) =>
        `letsgoapi/api/DraftRegistrationExcelExport/${eventID}`,
    GET_USER_INVITATION: (userID, code, modifyBy) =>
        `letsgoapi/api/GetUserInvitation/${userID}/${code}/${modifyBy}`,
    GET_REGISTRATION_HISTORY: (registrationID) =>
        `letsgoapi/api/GetRegistrationHistory/${registrationID}`,
    GET_TRANSPORT_MASTER: (eventID, transportID) =>
        `letsgoapi/api/GetTransportMaster/${eventID}/${transportID}`,
    GET_HOTEL_BOOK_MASTER: (eventID, hotelBookID) =>
        `letsgoapi/api/GetHotelBookMaster/${eventID}/${hotelBookID}`,
    GET_HOTEL_HISTORY: (hotelBookingId) =>
        `letsgoapi/api/GetHotelHistoryInfo/${hotelBookingId}`,
    POST_INS_RESOURCE: 'letsgoapi/api/CreateResource',
    GET_RESOURCE: (eventID) => `letsgoapi/api/GetResource/${eventID}`,
    POST_RESOURCE_PARTICIPANTS: 'letsgoapi/api/SaveResourceParticipants',
    GET_RESOURCE_PARTICIPANTS: (resourceID) =>
        `letsgoapi/api/GetResourceParticipants/${resourceID}`,
    DELETE_RESOURCE_PARTICIPANTS: 'letsgoapi/api/DeleteResourceParticipants',
    DELETE_RESOURCE: 'letsgoapi/api/DeleteResource',
    GET_MY_RESOURCE: (eventID, userID) =>
        `letsgoapi/api/GetMyResource/${eventID}/${userID}`,
    GET_MY_RESOURCE_COUNT: (eventID, userID) =>
        `letsgoapi/api/GetMyResourceCount/${eventID}/${userID}`,
    GET_TRANSPORT_HISTORY: (transportID, type) =>
        `letsgoapi/api/GetTransportHistory/${transportID}/${type}`,
    SEND_INDIVIDUAL_SCHEDULE: (eventid, userType, modifyBy) =>
        `letsgoapi/api/sendIndividualSchedulePDF/${eventid}/${userType}/${modifyBy}`,
    DOWNLOAD_INDIVIDUAL_SCHEDULE: (eventid, userID, userType, isPublished) =>
        `letsgoapi/api/downloadIndividualSchedulePDF/${eventid}/${userID}/${userType}/${isPublished}`,
    DOWNLOAD_INDIVIDUAL_BULK_SCHEDULE: (eventid, userType, isPublished) =>
        `letsgoapi/api/downloadIndividualBulkSchedulePDF/${eventid}/${userType}/${isPublished}`,
    POST_NOTIFICATION: 'letsgoapi/api/saveNotification',
    POST_SEND_NOTIFICATION: 'letsgoapi/api/SendNotification',
    GET_NOTIFICATION: (eventID) => `letsgoapi/api/getNotifications/${eventID}`,
    DELETE_NOTIFICATION_LIST: 'letsgoapi/api/DeleteNotifications',
    POST_NOTIFICATION_PARTICIPANTS:
        'letsgoapi/api/saveNotificationParticipants',
    GET_NOTIFICATION_PARTICIPANTS: (notificationID) =>
        `letsgoapi/api/GetNotificationParticipants/${notificationID}`,
    DELETE_NOTIFICATION_PARTICIPANTS:
        'letsgoapi/api/DeleteNotificationParticipants',
    UPDATE_NOTIFICATION: 'letsgoapi/api/UpdateNotification',
    POST_EDIT_EVENT_PARTICIPANT_ROW: `letsgoapi/api/UpdEventAllParticipant`,
    GET_TICKETS: (eventID, isAdmin, userID) =>
        `letsgoapi/api/GetTicketRequest/${eventID}/${isAdmin}/${userID}`,
    DELETE_TICKETS: 'letsgoapi/api/DeleteTickets',
    GET_TICKETS_CONFIG: (eventID, moduleID) =>
        `letsgoapi/api/GetTicketConfig/${eventID}/${moduleID}`,
    GET_TICKET_CONFIG: (eventID, moduleID) =>
        `letsgoapi/api/GetTicketConfig/${eventID}/${moduleID}`,
    POST_TICKET_CONFIG: `letsgoapi/api/InsertUpdateConfig`,
    UPDATE_EVENT_STATUS: `letsgoapi/api/UpdateTicketStatus`,
    GET_DRAFT_REGISTRATION_HISTORY: (registrationID) =>
        `letsgoapi/api/GetDraftRegistrationHistory/${registrationID}`,
    GET_DRAFT_REGISTRATION_LIST: (eventID, currentPage, perPage) =>
        `letsgoapi/api/GetDraftRegistrationList/${eventID}/${currentPage}/${perPage}`,
    GET_EVENT_DRAFT_REGISTRATION: (registrationID) =>
        `letsgoapi/api/GetEventDraftRegistration/${registrationID}`,
    GET_EVENT_DRAFT_REGISTRATION_INFO: (eventID, userID) =>
        `letsgoapi/api/EventDraftRegistrationInfo/${eventID}/${userID}`,
    UPDATE_DRAFT_REGISTRATION_NOTE: 'letsgoapi/api/EventDraftRegistrationNote',
    POST_SET_DRAFT_REGISTRATION_EMAIL_NOTIFICATION:
        'letsgoapi/api/SetDraftRegistrationEmailNotification',
    POST_DRAFT_REGISTRATION_INFO: `letsgoapi/api/draftregistrationinfo`,
    DELETE_DRAFT_REGISTRATION: 'letsgoapi/api/DeleteEventDraftRegRequest',
    UPDATE_SHARED_STATUS_ADMIN_DRAFT_REGISTRATION:
        'letsgoapi/api/UpdateStatusOrSharedDraftRegRequest',
    POST_TICKET: `letsgoapi/api/InsUpdTicketRequest`,
    GET_HOTEL_ROOM_TYPE: 'letsgoapi/api/GetHotelRoomType',
    GET_HOTEL_ROOM_TAX: 'letsgoapi/api/GetHotelRoomTax',
    GET_EVENT_DEFAULTS: (eventID, tagID, UserID) =>
        `letsgoapi/api/GetEventDefaults/${eventID}/${tagID}/${UserID}`,
    GET_TICKET_BY_TICKETID: (ticketID) =>
        `letsgoapi/api/GetTicketRequestByTicketID/${ticketID}`,
    POST_UPD_DRAFT_HOTEL: 'letsgoapi/api/InsUpdDraftHotel',
    GET_TICKET_HISTORY: (TicketID) =>
        `letsgoapi/api/GetTicketHistoryInfo/${TicketID}`,
    SEND_TICKET_EMAIL_NOTIFICATION: 'letsgoapi/api/SetTicketEmailNotification',
    POST_UPD_DRAFT_HOTELBOOKING: 'letsgoapi/api/UpdateDraftHotel',
    POST_ParticipantExport: `letsgoapi/api/ParticipantExport`,
    FORGOT_PASSWORD: `letsgoapi/api/ForgotPassword`,
    Update_Excluded_Email: `letsgoapi/api/UpdExcludedEmail`,
    POST_RESET_PASSWORD: 'letsgoapi/api/ResetPassword',
    POST_PUBLISH_ACTIVITY:
        `letsgoapi/api/PublishActivity`,
    POST_PUBLISH_ACTIVITY_SAVE_APP_NOTIFICATION:
        `letsgoapi/api/PublishActivitySaveAppNotification`,
    DELETE_EVENT_MODULE: 'letsgoapi/api/DeleteModule',
    GET_CONFIG: () => `letsgoapi/api/GetConfig/`,
    SAVE_APP_NOTIFICATION: `letsgoapi/api/saveAppNotification`,
    GET_APP_NOTIFICATIONS: (userID) =>
        `letsgoapi/api/getAppNotifications/${userID}`,
    DELETE_APP_NOTIFICATIONS: 'letsgoapi/api/deleteAppNotification',
    UPDATE_APP_NOTIFICATIONS: 'letsgoapi/api/updateAppNotification',
    GET_APP_NOTIFICATION_COUNT: (userID) =>
        `letsgoapi/api/getAppNotificationCount/${userID}`,
    DELETE_NON_MODULE_APP_NOTIFICATIONS:
        'letsgoapi/api/deleteNonModuleAppNotification',
    GET_ACTIVITY_PARTICIPANT_LIST_BY_EVENT_ID: (eventID, scheduleType) =>
        `letsgoapi/api/GetActivityParticipantsListBYEventID/${eventID}/${scheduleType}`,
    GET_USER_ACTIVITY_PUBLISHED: (eventId, userId, userType) =>
        `letsgoapi/api/GetActivityPublished/${eventId}/${userId}/${userType}`,
    POST_VIP: 'letsgoapi/api/InsUpdVip',
    GET_VIP_INFO: (eventID, userID) =>
        `letsgoapi/api/GetVipInfo/${eventID}/${userID}`,
    GET_VIP_HISTORY: (vipID) => `letsgoapi/api/GetVipHistoryInfo/${vipID}`,
    GET_SOCIAL_RESPONSIBILITY: (eventId, userId, moduleID) =>
        `letsgoapi/api/GetSocialResposibility/${eventId}/${userId}/${moduleID}`,
    ADD_UPDATE_SOCIAL_RESPONSIBILITY: 'letsgoapi/api/AddUpdSocialResposibility',
    GET_MEDIA_CIRCUIT: (eventID) =>
        `letsgoapi/api/GetMediaCircuitList/${eventID}`,
    GET_EVENT_USER_MEDIA_CIRCUIT: (eventID) =>
        `letsgoapi/api/GetEventUserMediaCircuit/${eventID}`,
    UPDATE_MEDIA_CIRCUIT_ACTIVITY_ORDER: `letsgoapi/api/UpdateMediaCircuitActivityOrder`,
    POST_USER_MEDIA_CIRCUIT_ACCESS: 'letsgoapi/api/UpdUserMediaCircuit',
    POST_INS_MEDIA_CIRCUIT: 'letsgoapi/api/MediaCircuit',
    DELETE_MEDIA_CIRCUIT: 'letsgoapi/api/DeleteMediaCircuit',
    DELETE_VIP: 'letsgoapi/api/DeleteVip',
    UPDATE_VIP_STATUS: `letsgoapi/api/UpdateVipStatus`,
    SET_USER_MEDIA_CIRCUIT_TIME: `letsgoapi/api/SetUserMediaCircuitTime`,
    GET_MEDIA_CIRCUIT_PARTICIPANT: (eventID, userID) =>
        `letsgoapi/api/GetMediaCircuitParticipant/${eventID}/${userID}`,
    GET_SAT_NIGHT_TRANSPORT_LIST: (eventID, currentPage, perPage) =>
        `letsgoapi/api/GetNightTransportList/${eventID}/${currentPage}/${perPage}`,
    GET_USER_SAT_NIGHT_TRANSPORT_LIST: (
        eventID,
        userID,
        currentPage,
        perPage
    ) =>
        `letsgoapi/api/GetUsersNightTransportList/${eventID}/${userID}/${currentPage}/${perPage}`,
    ADD_UPDATE_SAT_NIGHT_TRANSPORT: 'letsgoapi/api/InsUpdSatNight',
    DELETE_SATNIGHT: 'letsgoapi/api/DeleteSatNight',
    DELETE_PRIVATE_TRANSPORT: 'letsgoapi/api/DeletePrivateTransportRequest',
    UPD_STATUS_SHARED_SAT_NIGHT:
        'letsgoapi/api/UpdateStatusOrSharedSatNightRequest',
    POST_SAT_NIGHT_TRANSPORT_NOTE: 'letsgoapi/api/SatNightNote',
    GET_ALL_SOCIAL_RESPOSIBILITY: (eventID) =>
        `letsgoapi/api/GetAllSocialResposibility/${eventID}`,
    GET_ACTIVITY_TRACKER_AUDIT_DETAILS: (eventID) =>
        `letsgoapi/api/GetEventTrackerAuditDetails/${eventID}`,
    SEND_ACTIVITY_TRACKER_EMAIL: `letsgoapi/api/SendCombineTrackerEmail`,
    GET_ACTIVITY_TRACKER_EMAIL_CONFIG: (eventID, type) => `letsgoapi/api/GetTrackerEmailConfig/${eventID}/${type}`,
    SAVE_ACTIVITY_TRACKER_EMAIL_INFO: `letsgoapi/api/SaveActivityTrackerEmailConfig`,
    UPDATE_ACTIVITY_TRACKER_ORDER: `letsgoapi/api/UpdateActivityTrackerOrder`,
    GET_SAT_NIGHT_TRANSPORT_HISTORY: (satNightTransportID) =>
        `letsgoapi/api/GetSatNightHistoryInfo/${satNightTransportID}`,
    POST_USER_MEDIA_CIRCUIT_MARK_ACTIVITIES:
        'letsgoapi/api/UpdUserMediaCircuitAllActivities',
    GET_MEDIA_CIRCUIT_AUDIT_LIST: (eventID, auditType) =>
        `letsgoapi/api/GetMediaCircuitAuditList/${eventID}/${auditType}`,
    GET_MEDIA_CIRCUIT_MARK_ACTIVITIES: (eventID) =>
        `letsgoapi/api/GetMediaCircuitMarkActivityList/${eventID}`,
    GET_EVENT_USER_MEDIA_CIRCUIT_MARK_ACTIVITIES: (eventID) =>
        `letsgoapi/api/GetEventUserMediaCircuitMarkActivities/${eventID}`,
    DELETE_SOCIAL_RESPONSIBILITY:
        'letsgoapi/api/DeleteSocialResponsibilityRequest',
    POST_SOCIAL_RESPONSIBILITY_ADD_ACTIVITY:
        'letsgoapi/api/InsUpdSRAddactivity',
    GET_SOCIAL_RESPONSIBILITY_ADD_ACTIVITY_LIST: (eventId) =>
        `letsgoapi/api/GetSocialResposibilityActivityList/${eventId}`,
    Del_SOCIAL_RESPONSIBILITY_ADD_ACTIVITY: 'letsgoapi/api/DelSRAddactivity',
    UPDATE_MEDIA_CIRCUIT_LOCATION: 'letsgoapi/api/UpdateMediaCircuitLocation',
    UPDATE_MULTI_SELECT_STATUS: 'letsgoapi/api/MultiSelectUpdateStatus',
    POST_ALLSTAR_TICKETS: 'letsgoapi/api/InsUpdTicketAllStarSetting',
    GET_TICKET_ALLSTAR_SETTING: (eventId) =>
        `letsgoapi/api/GetTicketAllStarSetting/${eventId}`,
    DELETE_ALLSTAR_TICKETS_SETTING: 'letsgoapi/api/DeleteTicketAllStarSetting',
    UPD_SOCIALRESPONSIBILITY_STATUS: 'letsgoapi/api/UpdateSocialRespStatus',
    UPD_SOCIALRESPONSIBILITY_NOTE: 'letsgoapi/api/UpdSocialRespNote',
    GET_ALLSTAR_TICKET_PRICE: (eventID) =>
        `letsgoapi/api/GetTicketPrice/${eventID}`,
    POST_ALLSTAR_EVENT_TICKETS: 'letsgoapi/api/InsUpdTicketAllStar',
    GET_TICKET_ALLSTAR: (eventID, userID, isAdmin) =>
        `letsgoapi/api/GetTicketAllStar/${eventID}/${userID}/${isAdmin}`,
    DELETE_ALLSTAR_TICKET: 'letsgoapi/api/DeleteTicketAllStar',
    POST_ALLSTAR_EVENT_COMP_TICKETS: 'letsgoapi/api/InsUpdTicketAllStarComp',
    DELETE_ALLSTAR_TICKETS_DETAIL: 'letsgoapi/api/DeleteTicketAllStarDetail',
    SUBMIT_ALLSTAR_TICKETS: 'letsgoapi/api/SubmitAllStarTicket',
    POST_HOTEL_TICKET_SETTING: 'letsgoapi/api/InsertUpdateHotelTicketSetting',
    GET_HOTEL_TICKET_SETTING: (eventID, type) =>
        `letsgoapi/api/GetHotelTicketSetting/${eventID}/${type}`,
    DELETE_HOTEL_SETTING: 'letsgoapi/api/DeleteHotelTicketSetting',
    GET_TICKET_ALLSTAR_SETTING_BY_USERID: (eventID, userID) =>
        `letsgoapi/api/GetTicketAllStarSettingByUserID/${eventID}/${userID}`,
    GET_EVENT_ALLOTMENTS: (eventID, userID) =>
        `letsgoapi/api/EventAllotments/${eventID}/${userID}`,
    GET_EVENT_MODULES_PERMISSION: (eventID, userID) =>
        `letsgoapi/api/GetEventMainModulePermissions/${eventID}/${userID}`,
    POST_NOTIFICATION_ON_OFF: 'letsgoapi/api/NotificationONOrOFF',
    POST_ALLSTAR_REGISTRATION_INFO: 'letsgoapi/api/AllStarRegistrationInfo',
    GET_ALLSTAR_REGISTRATION_LIST: (eventID, currentPage, perPage) =>
        `letsgoapi/api/GetALLStarRegistrationList/${eventID}/${currentPage}/${perPage}`,
    DELETE_ALLSTAR_REGISTRATION: 'letsgoapi/api/DeleteEventAllStarRegRequest',
    UPDATE_SHARED_STATUS_ADMIN_ALLSTAR_REGISTRATION:
        'letsgoapi/api/UpdateStatusOrSharedAllStarRegRequest',
    UPDATE_ALLSTAR_REGISTRATION_NOTE:
        'letsgoapi/api/EventAllStarRegistrationNote',
    GET_EVENT_ALLSTAR_REGISTRATION: (registrationID) =>
        `letsgoapi/api/GetEventAllStarRegistration/${registrationID}`,
    GET_ALLSTAR_REGISTRATION_HISTORY: (registrationID) =>
        `letsgoapi/api/GetAllStarRegistrationHistory/${registrationID}`,
    POST_PAYMENT_METHOD: 'letsgoapi/api/PaymentMethod',
    POST_SET_ALLSTAR_REGISTRATION_EMAIL_NOTIFICATION:
        'letsgoapi/api/SetAllStarRegistrationEmailNotification',
    GET_EVENT_ALLSTAR_REGISTRATION_INFO: (eventID, userID) =>
        `letsgoapi/api/EventAllStarRegistrationInfo/${eventID}/${userID}`,
    POST_SUB_ACTIVITY_LIST: 'letsgoapi/api/SubActivity',
    DELETE_SUB_ACTIVITY_LIST: 'letsgoapi/api/DeleteSubActivity',
    UPDATE_ALLSTAR_TICKET_STATUS: `letsgoapi/api/UpdateAllStarTicketStatus`,
    GET_HOTELALLSTAR_SETTING_BY_USERID: (eventID, userID) =>
        `letsgoapi/api/GetHotelAllStarSettingByUserID/${eventID}/${userID}`,
    GET_PAYEE_DETAILS: (userID) => `letsgoapi/api/GetPayDetails/${userID}`,
    GET_PREV_DETAILS: (userID, connectID) =>
        `letsgoapi/api/GetPrevDetails/${userID}/${connectID}`,
    GET_TRANSPORT_SETTING_BY_USER_ID: (eventID, UserID) =>
        `letsgoapi/api/GetTransportSettingByUserID/${eventID}/${UserID}`,
    GET_MOBILE_PUSH_NOTIFICATION: (
        UserID,
        eventID,
        eventName,
        moduleName,
        status
    ) =>
        `letsgoapi/api/PushMobileNotification/${UserID}/${eventID}/${eventName}/${moduleName}/${status}`,
    GET_PUSH_NOTIFICATION: (UserID, eventID, eventName) =>
        `letsgoapi/api/PushNotification/${UserID}/${eventID}/${eventName}`,
    SAVE_APP_NOTIFICATION_SETTING: 'letsgoapi/api/saveAppNotificationSettings',
    GET_USER_NOTIFICATION_SETTING: (eventID, UserID) =>
        `letsgoapi/api/GetUserNotificationSetting/${eventID}/${UserID}`,
    CONTACT_US_EMAIL: 'letsgoapi/api/ContactusEmail',
    SAVE_BULK_NOTIFICATION: 'letsgoapi/api/saveBulkAppNotificationSettings',
    GET_Event_NOTIFICATION_SETTING: (eventID) =>
        `letsgoapi/api/GetEventUserNotifications/${eventID}`,
    POST_NOTES: 'letsgoapi/api/saveNotes',
    GET_NOTES: (eventID) => `letsgoapi/api/getNotes/${eventID}`,
    GET_INSTRUCTIONS: (eventID) => `letsgoapi/api/GetInstructions/${eventID}`,
    GET_PARTICIPANT_INSTRUCTIONS_USER: (eventID, userID) => `letsgoapi/api/GetParticipantsInstructionUser/${eventID}/${userID}`,
    GET_PARTICIPANT_INSTRUCTIONS: (eventID, userID) => `letsgoapi/api/GetParticipantsInstruction/${eventID}/${userID}`,
    SAVE_INSTRUCTIONS: 'letsgoapi/api/saveInstruction',
    DELETE_NOTES_LIST: 'letsgoapi/api/DeleteNotes',
    DELETE_INSTRUCTION: 'letsgoapi/api/DeleteInstructions',
    POST_NOTES_PARTICIPANTS: 'letsgoapi/api/saveNotesParticipants',
    POST_EVENT_INSTRUCTION_PARTICIPANTS: 'letsgoapi/api/SaveInstructionParticipants',
    GET_NOTES_PARTICIPANTS: (notesID) =>
        `letsgoapi/api/GetNotesParticipants/${notesID}`,
    GET_EVENT_INSTRUCTION_PARTICIPANTS: (id) =>
        `letsgoapi/api/GetInstructionParticipants/${id}`,
    DELETE_NOTES_PARTICIPANTS: 'letsgoapi/api/DeleteNotesParticipants',
    DELETE_INSTRUCTION_PARTICIPANTS: 'letsgoapi/api/DeleteInstructionParticipants',
    GET_NOTES_USER: (eventID, userID) =>
        `letsgoapi/api/GetParticipantsNotes/${eventID}/${userID}`,
    POST_TICKET_ALL_STAR_NOTIFICATION_EMAIL:
        'letsgoapi/api/SetTicketAllStarAuditEmailNotification',
    GET_CHARGE_PAYMENT_DETAILS: () => `letsgoapi/api/GetChargePaymentDetails`,
    POST_CHARGE_DETAILS: 'letsgoapi/api/ChargePayments',
    GET_ADMIN_DRAFT_TRANSPORT_LIST: (eventID, currentPage, perPage) =>
        `letsgoapi/api/GetAdminDraftTransportList/${eventID}/${currentPage}/${perPage}`,
    GET_ADMIN_TRANSPORT_SUMMARY_LIST: (eventID, currentPage, perPage) =>
        `letsgoapi/api/GetAdminTransportSummaryList/${eventID}/${currentPage}/${perPage}`,
    GET_TAGID_BY_USERID: (eventID, userID) =>
        `letsgoapi/api/GetEventTagsByUserID/${eventID}/${userID}`,
    GET_SHARED_ADMIN_DRAFT_TRANSPORT_LIST: (transportID, shared, modifiedBy) =>
        `letsgoapi/api/UpdateSharedStatusDraftTransportList/${transportID}/${shared}/${modifiedBy}`,
    GET_STATUS_ADMIN_DRAFT_TRANSPORT_LIST: (transportID, status, modifiedBy, isMail) =>
        `letsgoapi/api/UpdateStatusDraftTransportList/${transportID}/${status}/${modifiedBy}/${isMail}`,
    POST_DRAFT_TRANSPORT_NOTE: 'letsgoapi/api/DraftTransportNote',
    DELETE_DRAFT_TRANSPORT: 'letsgoapi/api/DeleteDraftTransport',
    GET_DRAFT_TRANSPORT_MASTER: (eventID, transportID) =>
        `letsgoapi/api/GetDraftTransportMaster/${eventID}/${transportID}`,
    GET_DRAFT_TRANSPORT_HISTORY: (transportID, type) =>
        `letsgoapi/api/GetDraftTransportHistory/${transportID}/${type}`,
    POST_INS_DRAFT_AIR_TRANSPORT: 'letsgoapi/api/InsDraftAirTransport',
    POST_SET_DRAFT_AIR_EMAIL_NOTIFICATION:
        'letsgoapi/api/SetDraftAirEmailNotification',
    POST_SET_DRAFT_GROUND_EMAIL_NOTIFICATION:
        'letsgoapi/api/SetDraftGroundEmailNotification',
    POST_UPD_DRAFT_AIR_TRANSPORT: 'letsgoapi/api/UpdDraftAirTransport',
    POST_UPD_DRAFT_GND_TRANSPORT: 'letsgoapi/api/InsUpdDraftGroundTransport',
    GET_DRAFT_AIRTRANSPORT_ROW: (transitID) =>
        `letsgoapi/api/GetDraftAirTransportRow/${transitID}`,
    GET_DRAFT_GNDTRANSPORT_ROW: (transitID) =>
        `letsgoapi/api/GetDraftGroundTransportRow/${transitID}`,
    DRAFT_UPDATE_MULTI_SELECT_STATUS: 'letsgoapi/api/MultiSelectUpdateStatus',
    GET_DRAFT_TRANSPORT_LIST: (eventID, userID, currentPage, perPage) =>
        `letsgoapi/api/GetDraftTransportList/${eventID}/${userID}/${currentPage}/${perPage}`,
    GET_DRAFT_TRANSPORT_SETTING_BY_USER_ID: (eventID, UserID) =>
        `letsgoapi/api/GetDraftTransportSettingByUserID/${eventID}/${UserID}`,

    GET_ADMIN_DRAFT_COMBINE_TRANSPORT_LIST: (eventID, currentPage, perPage) =>
        `letsgoapi/api/GetAdminDraftCombineTransportList/${eventID}/${currentPage}/${perPage}`,
    GET_SHARED_ADMIN_DRAFT_COMBINE_TRANSPORT_LIST: (
        transportID,
        shared,
        modifiedBy
    ) =>
        `letsgoapi/api/UpdateSharedStatusDraftCombineTransportList/${transportID}/${shared}/${modifiedBy}`,
    GET_STATUS_ADMIN_DRAFT_COMBINE_TRANSPORT_LIST: (
        transportID,
        status,
        modifiedBy,
        isMail
    ) =>
        `letsgoapi/api/UpdateStatusDraftCombineTransportList/${transportID}/${status}/${modifiedBy}/${isMail}`,
    POST_DRAFT_COMBINE_TRANSPORT_NOTE:
        'letsgoapi/api/DraftCombineTransportNote',
    DELETE_DRAFT_COMBINE_TRANSPORT: 'letsgoapi/api/DeleteDraftCombineTransport',
    GET_DRAFT_COMBINE_TRANSPORT_MASTER: (eventID, transportID) =>
        `letsgoapi/api/GetDraftCombineTransportMaster/${eventID}/${transportID}`,
    GET_DRAFT_COMBINE_TRANSPORT_HISTORY: (transportID, type) =>
        `letsgoapi/api/GetDraftCombineTransportHistory/${transportID}/${type}`,
    POST_INS_DRAFT_COMBINE_AIR_TRANSPORT:
        'letsgoapi/api/InsDraftCombineAirTransport',
    POST_SET_DRAFT_COMBINE_AIR_EMAIL_NOTIFICATION:
        'letsgoapi/api/SetDraftCombineAirEmailNotification',
    POST_SET_DRAFT_COMBINE_GROUND_EMAIL_NOTIFICATION:
        'letsgoapi/api/SetDraftCombineGroundEmailNotification',
    POST_UPD_DRAFT_COMBINE_AIR_TRANSPORT:
        'letsgoapi/api/UpdDraftCombineAirTransport',
    POST_UPD_DRAFT_COMBINE_GND_TRANSPORT:
        'letsgoapi/api/InsUpdDraftCombineGroundTransport',
    GET_DRAFT_COMBINE_AIRTRANSPORT_ROW: (transitID) =>
        `letsgoapi/api/GetDraftCombineAirTransportRow/${transitID}`,
    GET_DRAFT_COMBINE_GNDTRANSPORT_ROW: (transitID) =>
        `letsgoapi/api/GetDraftCombineGroundTransportRow/${transitID}`,
    DRAFT_COMBINE_UPDATE_MULTI_SELECT_STATUS:
        'letsgoapi/api/MultiSelectUpdateStatus',
    GET_DRAFT_COMBINE_TRANSPORT_LIST: (eventID, userID, currentPage, perPage) =>
        `letsgoapi/api/GetDraftCombineTransportList/${eventID}/${userID}/${currentPage}/${perPage}`,
    GET_DRAFT_COMBINE_TRANSPORT_SETTING_BY_USER_ID: (eventID, UserID) =>
        `letsgoapi/api/GetDraftCombineTransportSettingByUserID/${eventID}/${UserID}`,

    GET_DRAFT_HOTELBOOKING_LIST: (
        eventID,
        userID,
        isAdmin,
        expanded,
        currentPage,
        perPage
    ) =>
        `letsgoapi/api/GetDraftHotelBookingList/${eventID}/${userID}/${isAdmin}/${expanded}/${currentPage}/${perPage}`,
    GET_COMBINE_HOTELBOOKING_LIST: (
        eventID,
        userID,
        isAdmin,
        expanded,
        currentPage,
        perPage
    ) =>
        `letsgoapi/api/GetCombineHotelBookingList/${eventID}/${userID}/${isAdmin}/${expanded}/${currentPage}/${perPage}`,
    POST_UPD_AllSTAR_HOTEL: 'letsgoapi/api/InsUpdAllStarHotel',
    POST_UPD_ALLSTAR_HOTELBOOKING: 'letsgoapi/api/UpdateAllStarHotel',
    GET_DRAFT_HOTEL_ROOM_TYPE: 'letsgoapi/api/GetDraftHotelRoomType',
    GET_DRAFT_HOTEL_ROOM_TAX: 'letsgoapi/api/GetDraftHotelRoomTax',
    DELETE_ALLSTAR_HOTELBOOKING: 'letsgoapi/api/DeleteAllStarHotelRequest',
    POST_STATUS_OR_SHARE_ALLSTAR_HOTEL:
        'letsgoapi/api/AllStarHotelUpdateStatusOrSharedRequest',
    GET_DRAFT_HOTEL_HISTORY: (hotelBookingId) =>
        `letsgoapi/api/GetDraftHotelHistoryInfo/${hotelBookingId}`,
    GET_COMBINE_HOTEL_HISTORY: (hotelBookingId) =>
        `letsgoapi/api/GetCombineHotelHistoryInfo/${hotelBookingId}`,
    POST_DRAFT_HOTELBOOKING_NOTE: 'letsgoapi/api/DraftHotelBookingNote',
    POST_COMBINE_HOTELBOOKING_NOTE: 'letsgoapi/api/CombineHotelBookingNote',
    GET_DRAFT_HOTEL_BOOK_MASTER: (eventID, hotelBookID) =>
        `letsgoapi/api/GetDraftHotelBookMaster/${eventID}/${hotelBookID}`,
    GET_COMBINE_HOTEL_BOOK_MASTER: (eventID, hotelBookID) =>
        `letsgoapi/api/GetCombineHotelBookMaster/${eventID}/${hotelBookID}`,
    GET_COMBINE_REGISTRATION: (eventID) =>
        `letsgoapi/api/GetCombineRegistration/${eventID}`,
    GET_COMBINE_REGISTRATION_USER: (eventID, userID) =>
        `letsgoapi/api/GetCombineRegistrationUser/${eventID}/${userID}`,
    UPD_COMPBINE_REGISTRATION_USER: 'letsgoapi/api/UpdCombineRegistrationUser',
    POST_WELCOME_EMAIL: 'letsgoapi/api/WelcomeEmail',
    GET_OUTFIT_TYPES: (eventID) => `letsgoapi/api/GetOutfitTypes/${eventID}`,
    PARTICIPANT_EVENT_PUBLISHED: 'letsgoapi/api/UserWiseEventPublished',
    PARTICIPANT_EVENT_PUBLISHED_EMAIL: 'letsgoapi/api/UserWiseEventPublishedEmail',
    GET_SCHEDULE_PUBLISHED: (eventID, userID) =>
        `letsgoapi/api/GetSchedulePublished/${eventID}/${userID}`,
    GET_HOTEL_DATE_SETTING: (eventID) =>
        `letsgoapi/api/GetHotelDateSetting/${eventID}`,
    GET_TRANSPORT_DATE_SETTING: (eventID) =>
        `letsgoapi/api/GetTransportDateSetting/${eventID}`,
    GET_ROSTER_MANAGEMENT: (eventID) =>
        `letsgoapi/api/GetRoasterManagement/${eventID}`,
    GET_ROSTER_TEAMS: (eventID) =>
        `letsgoapi/api/GetRoasterTeams/${eventID}`,
    UPDATE_PLAYER_TEAM: `letsgoapi/api/UpdatePlayerTeam`,
    DOWNLOAD_INDIVIDUAL_SCHEDULE_EXPORT: (eventid) =>
        `letsgoapi/api/downloadIndividualBulkExport/${eventid}`,
    GET_DRAFT_TICKET_SETTING_BYUSERID: (eventID, UserID) =>
        `letsgoapi/api/GetDraftTicketSettingByUserID/${eventID}/${UserID}`,
    GET_DRAFT_HOTEL_SETTING_BY_USERID: (eventID, userID) =>
        `letsgoapi/api/GetDraftHotelSettingByUserID/${eventID}/${userID}`,
    GET_WEATHER_INFO: (city) => `letsgoapi/api/GetWeather/${city}`,
    GET_WEATHER_STATE_INFO: (city) => `letsgoapi/api/GetWeatherState/${city}`,
    GET_STATE_INFO: (state) => `letsgoapi/api/GetState/${state}`,
    CHECK_MODULE_DATA_EXIST_FOR_USER: (moduleID, eventID, userID, registrationID) => `letsgoapi/api/CheckModuleDataExistForUser/${moduleID}/${eventID}/${userID}/${registrationID}`,
    GET_HOME_DETAILS: (eventID) => `letsgoapi/api/GetHomeDetails/${eventID}`,
    GET_PARTICIPANT_HOME_DETAILS_USER: (eventID, userID) => `letsgoapi/api/GetParticipantsHomeDetail/${eventID}/${userID}`,
    GET_PARTICIPANT_HOME_DETAILS: (eventID, userID) => `letsgoapi/api/GetParticipantsHomeDetail/${eventID}/${userID}`,
    SAVE_HOME_DETAILS: 'letsgoapi/api/saveHomeDetail',
    DELETE_HOME_DETAIL: 'letsgoapi/api/DeleteHomeDetails',
    POST_EVENT_HOME_DETAIL_PARTICIPANTS: 'letsgoapi/api/SaveHomeDetailParticipants',
    GET_EVENT_HOME_DETAIL_PARTICIPANTS: (id) =>
        `letsgoapi/api/GetHomeDetailParticipants/${id}`,
    DELETE_HOME_DETAIL_PARTICIPANTS: 'letsgoapi/api/DeleteHomeDetailParticipants',
    GET_PRIVATE_TRANSPORT_LIST: (eventID) =>
        `letsgoapi/api/GetPrivateTransportList/${eventID}`,
    ADD_UPDATE_PRIVATE_TRANSPORT: 'letsgoapi/api/InsUpdPrivateTransport',
    PRIVATE_TRANSPORT_UPDATE_NOTE:
        'letsgoapi/api/PrivateTransportNote',
    PRIVATE_TRANSPORT_UPDATE_STATUS:
        'letsgoapi/api/UpdateStatusOrSharedPrivateTransportRequest',
    GET_PRIVATE_TRANSPORT_HISTORY: (privateTransportID) =>
        `letsgoapi/api/GetPrivateTransportHistoryInfo/${privateTransportID}`,
    GET_PRIVATE_TRANSPORT: (eventID, userID) => `letsgoapi/api/GetPrivateTransport/${eventID}/${userID}`,
    ADD_UPDATE_KEY_CONTACT: 'letsgoapi/api/InsertUpdateKeyContact',
    GET_KEY_CONTACTS: (eventID) =>
        `letsgoapi/api/GetKeyContacts/${eventID}`,
    DELETE_KEY_CONTACTS: 'letsgoapi/api/DeleteGetKeyContact',
    GET_MODULE_CONFIG: (moduleID, type) => `letsgoapi/api/GetModuleConfig/${moduleID}/${type}`,
    GET_SOCIAL_RESP_HISTORY: (socialRespId, eventID) =>
        `letsgoapi/api/GetAllSocialResposibilityHistory/${socialRespId}/${eventID}`,
    UPDATE_KEY_CONTACT_ORDER: 'letsgoapi/api/UpdateKeyContactOrder',
    UPLOAD_TMCE_IMAGE_HANDLE: 'letsgoapi/api/UploadImageHandle',
    POST_INS_UPD_TRACKER: 'letsgoapi/api/InsUpdTracker',
    GET_ACTIVITY_TRACKER_LIST: (eventID) =>
        `letsgoapi/api/GetActivityTrackerList/${eventID}`,
    GET_EVENT_USER_ACTIVITY_TRACKER_ACCESS: (eventID) =>
        `letsgoapi/api/GetEventUserActivityTrackerAccess/${eventID}`,
    POST_USER_ACTIVITY_TRACKER_ACCESS: 'letsgoapi/api/UpdUserActivityTracker',
    GET_ACTIVITY_TRACKER_MARK_ACTIVITY_LIST: (eventID) =>
        `letsgoapi/api/GetActivityTrackerMarkList/${eventID}`,
    GET_EVENT_ACTIVITY_TRACKER_MARK_ACTIVITIES: (eventID) =>
        `letsgoapi/api/GetEventUserActivityTrackerMarkActivities/${eventID}`,
    POST_USER_ACTIVITY_TRACKER_MARK_ACTIVITIES:
        'letsgoapi/api/UpdUserMarkActivityTracker',
    DELETE_COMBINE_ACTIVITY_TRACKER: 'letsgoapi/api/DeleteActivityTracker',
    GET_EVENT_ACTIVITY_AUDIT_LIST: (eventID, auditType) =>
        `letsgoapi/api/GetEventActivityAuditList/${eventID}/${auditType}`,
    GET_CREDENTIALS: (eventID, isAdmin, userID) =>
        `letsgoapi/api/GetCredential/${eventID}/${isAdmin}/${userID}`,
    POST_CREDENTIALS: 'letsgoapi/api/InsUpdCredential',
    DELETE_CREDENTAIL: 'letsgoapi/api/DeleteCredentials',
    UPDATE_CREDENTIAL_STATUS: 'letsgoapi/api/UpdateCredentialStatus',
    GET_CREDENTIAL_HISTORY: (credentialID) =>
        `letsgoapi/api/GetCredentialHistoryInfo/${credentialID}`,
    GET_CREDENTIAL_BY_CREDID: (credentialID) =>
        `letsgoapi/api/GetCredentialByID/${credentialID}`,
    GET_CREDENTIAL_SETTING_BY_USERID: (eventID, userID) =>
        `letsgoapi/api/GetCredentialSettingByUserID/${eventID}/${userID}`,
    GET_COMBINE_FLIGHTINFO: (eventID, isAdmin, userID,) =>
        `letsgoapi/api/GetFlightInfo/${eventID}/${isAdmin}/${userID}`,
    GET_COMBINE_FLIGHTINFOBYID: (FlightInfoID) => `letsgoapi/api/GetFlightInfoByID/${FlightInfoID}`,
    GET_COMBINE_FLIGHTINFOHISTORY: (FlightInfoID) => `letsgoapi/api/GetFlightInfoHistory/${FlightInfoID}`,
    POST_COMBINEFLIGHTINFO: 'letsgoapi/api/InsUpdFlightInfo',
    DELETE_COMBINEFLIGHTINFO: 'letsgoapi/api/DeleteFlightInfos',
    UPDATE_COMBINEFLIGHTINFO_STATUS: 'letsgoapi/api/UpdateFlightInfoStatus',
    GET_COMBINEFLIGHTINFO_HISTORY: (FlightInfoID) =>
        `letsgoapi/api/GetFlightInfoHistory/${FlightInfoID}`,
    GET_COMBINEFLIGHTINFO_SETTING_BY_USERID: (eventID, userID) =>
        `letsgoapi/api/GetFlightInfoSettingByUserID/${eventID}/${userID}`,
    GET_MY_STATS_RESULT: 'letsgoapi/api/GetMyStatsReport',
    DELETE_FLIGHT_INFO: 'letsgoapi/api/DeleteFlightInfos',
    GET_EVENT_MODULE_BY_EVENT_STAFF: (eventID, userID) =>
        `letsgoapi/api/GetEventModulesByEventStaff/${eventID}/${userID}`,
    DOWNLOAD_PROFILE_PIC_CREDENTIAL: (eventid) =>
        `letsgoapi/api/downloadPhoto/${eventid}`,
    GET_EVENT_PARTICIPANT_BY_USER_ID: (eventID, userID) =>
        `letsgoapi/api/EventParticipantByUserID/${eventID}/${userID}`,
    GET_CREDENTIALS_PIC_URL: (credentialID, eventID) =>
        `letsgoapi/api/GetCredentialPicUrl/${credentialID}/${eventID}`,
    POST_LUNCHROOM: 'letsgoapi/api/InsUpdLunchRoom',
    GET_LUNCHROOMS: (eventID, isAdmin, userID) =>
        `letsgoapi/api/GetLunchRoom/${eventID}/${isAdmin}/${userID}`,
    DELETE_LUNCHROOM: 'letsgoapi/api/DeleteLunchRooms',
    GET_LUNCHROOM_HISTORY: (LunchRoomID) =>
        `letsgoapi/api/GetLunchRoomHistoryInfo/${LunchRoomID}`,
    UPDATE_LUNCHROOM_STATUS: 'letsgoapi/api/UpdateLunchRoomStatus',
    GET_LUNCH_ROOM_SETTING_BY_USERID: (eventID, userID) =>
        `letsgoapi/api/GetLunchRoomSettingByUserID/${eventID}/${userID}`,

    GET_GREENROOMS: (eventID, isAdmin, userID) =>
        `letsgoapi/api/GetGreenRoom/${eventID}/${isAdmin}/${userID}`,
    POST_GREENROOM: 'letsgoapi/api/InsUpdGreenRoom',
    DELETE_GREENROOM: 'letsgoapi/api/DeleteGreenRooms',
    GET_GREENROOM_HISTORY: (GreenRoomID) =>
        `letsgoapi/api/GetGreenRoomHistoryInfo/${GreenRoomID}`,
    UPDATE_GREENROOM_STATUS: 'letsgoapi/api/UpdateGreenRoomStatus',
    GET_GREENROOM_PIC_URL: (greenRoomID, eventID) =>
        `letsgoapi/api/GetGreenRoomPicUrl/${greenRoomID}/${eventID}`,
    GET_GREEN_ROOM_SETTING_BY_USERID: (eventID, userID) =>
        `letsgoapi/api/GetGreenRoomSettingByUserID/${eventID}/${userID}`,

    // DRAFT FLIGHT INFO 
    INS_UPD_DRAFT_FLIGHT_INFO: 'letsgoapi/api/InsUpdDraftFlightInfo',
    GET_DRAFT_FLIGHT_INFO_LIST: (eventID, isAdmin, userID) =>
        `letsgoapi/api/GetDraftFlightInfo/${eventID}/${isAdmin}/${userID}`,
    GET_DRAFT_FLIGHT_INFO_HISTORY: (FlightInfoID) => `letsgoapi/api/GetDraftFlightInfoHistory/${FlightInfoID}`,
    DELETE_DRAFT_FLIGHT_INFO: 'letsgoapi/api/DeleteDraftFlightInfos',
    UPDATE_DRAFT_FLIGHT_INFO_STATUS: 'letsgoapi/api/UpdateDraftFlightInfoStatus',
    GET_DRAFT_FLIGHT_SETTING_BY_USERID: (eventID, userID) =>
        `letsgoapi/api/GetDraftFlightInfoSettingByUserID/${eventID}/${userID}`,        
    DOWNLOAD_PROFILE_PIC_GREENROOM: (eventid) =>
        `letsgoapi/api/GreenRoomDownloadPhoto/${eventid}`,
    FINALSUBMIT_LUNCHROOM: 'letsgoapi/api/FinalSubmitLunchRoom',
    FINALSUBMIT_GREENROOM: 'letsgoapi/api/FinalSubmitGreenRoom',
    DOWNLOAD_PARTICIPANT_CONNECTION: (eventid, UserIDs,Options) =>
        `letsgoapi/api/downloadParticipantConnectionPDF/${eventid}/${UserIDs}/${Options}`,
    UPDATE_CONTACT_LIST_ORDERS: 'letsgoapi/api/UpdateContactListOrder', 
    GET_CONTACT_LIST: (eventID) => `letsgoapi/api/getContactList/${eventID}`,
    GET_BULK_USER: () => `letsgoapi/api/GetBulkUsers`,
    UPDATE_BULK_USER:`letsgoapi/api/UpdateBulkUser`, 
    CHANGE_PASSWORD:`letsgoapi/api/ChangePassword`, 
    GET_MODULE_REMARKS: (eventID, moduleID) => `letsgoapi/api/GetModuleRemarks/${eventID}/${moduleID}`,
    ALLOTMENT_EVENT_MODULE_LIST: (eventID) =>
        `letsgoapi/api/AllotmentEventModuleList/${eventID}`,
    GET_EVENT_ALL_USER_MOUDLES_STATUS_BY_EVENTID: (eventID) =>
        `letsgoapi/api/GetEventAllUserModuleStatusByEventID/${eventID}`, 
};
export default APIURLConstants;
